import { FlagBox, FlagBoxProps } from '@agilelab/plugin-wb-platform';
import { useSearchContext } from '../context/SearchContext';

export const SearchFlagBox = (props: FlagBoxProps) => {
  const { policyViolationsInfo } = useSearchContext();
  const { error, data: value, isLoading: loading } = policyViolationsInfo;

  return (
    <FlagBox
      error={error instanceof Error ? error : undefined}
      loading={loading}
      policyViolationsCountMap={value}
      {...props}
    />
  );
};
